import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3d30941e"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "w-full lg:w-auto font-semibold text-24px lg-text-36px",
  style: {"color":"#064c29"}
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "2", -1))
const _hoisted_3 = { class: "flex flex-wrap space-x-2 items-center" }
const _hoisted_4 = {
  class: "text-16px lg-text-30px",
  style: {"color":"#6d7380"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "2", -1))
const _hoisted_6 = { class: "text-xl md:text-4xl" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { key: 3 }
const _hoisted_11 = { key: 4 }
const _hoisted_12 = { class: "meter" }

import { ref, onMounted } from 'vue';
import { ProgressRequest, ProgressResponse } from '@/types/MoralisCloud';
import { numberWithCommas } from '@/composables/format';
import useMoralis from '@/composables/useMoralis';
import Moralis from 'moralis/types';

interface Props {
  goal: string;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    goal: { default: 'yearly' }
  },
  setup(__props: any) {

const props = __props as { goal: string }

const moralis = useMoralis();

const progressWidth = ref(0);



const progress = ref<ProgressResponse>({
  progress: 0,
  percentage: 0,
  goal: 0,
});

onMounted(async () => {
  try {
    const res = await moralis.currect.Cloud.run<ProgressRequest>(
      'getProgress',
      {
        goal: props.goal,
      }
    );
    progress.value = res;
  } catch (err) {
    moralis.handleMoralisError(err as Moralis.Error);
  }

  let isProgressCounter = true;
  const checkProgressScroll = () => {
    const el = document.getElementById('progress');
    const rect = el?.getBoundingClientRect();
    if (
      isProgressCounter &&
      window.scrollY + document.body.offsetHeight > (rect?.top || 0)
    ) {
      progressWidth.value = progress.value.percentage;
      isProgressCounter = false;
    }
  };
  checkProgressScroll();
  window.addEventListener('scroll', () => {
    checkProgressScroll();
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_1, [
        _createTextVNode(_toDisplayString(_unref(numberWithCommas)(parseInt(`${progress.value.progress}`))) + " m", 1),
        _hoisted_2
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createTextVNode(" of " + _toDisplayString(_unref(numberWithCommas)(parseInt(`${progress.value.goal}`))) + " m", 1),
          _hoisted_5,
          _createTextVNode(" " + _toDisplayString(props.goal) + " goal ", 1)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (progress.value.percentage < 20)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, "😭🌳"))
            : (progress.value.percentage < 40)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, "🥲🌳"))
              : (progress.value.percentage < 60)
                ? (_openBlock(), _createElementBlock("span", _hoisted_9, "🙂🌳"))
                : (progress.value.percentage < 80)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "😊🌳"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_11, "🎉🎊🌳"))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("span", {
        id: "progress",
        style: _normalizeStyle(`width: ${progressWidth.value}%;`)
      }, null, 4)
    ])
  ]))
}
}

})